/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FreeBikeStatus } from '../model/freeBikeStatus';
import { Gbfs } from '../model/gbfs';
import { GeofencingZones } from '../model/geofencingZones';
import { StationInformation } from '../model/stationInformation';
import { StationStatus } from '../model/stationStatus';
import { SystemInformation } from '../model/systemInformation';
import { SystemPricingPlans } from '../model/systemPricingPlans';
import { SystemRegions } from '../model/systemRegions';
import { VehicleTypes } from '../model/vehicleTypes';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class GbfsApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get the status of free vehicles
     * Retrieve the list of currently available free bicycles
     * @param city The name of the city whose vehicle list you want to retrieve
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFreeBikeStatus(city: string, observe?: 'body', reportProgress?: boolean): Observable<FreeBikeStatus>;
    public getFreeBikeStatus(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FreeBikeStatus>>;
    public getFreeBikeStatus(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FreeBikeStatus>>;
    public getFreeBikeStatus(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getFreeBikeStatus.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FreeBikeStatus>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/free_bike_status.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Auto-discovery file that links to all of the other files published by the system
     * Retrieves the GBFS feed for a specific city
     * @param city The name of the city for which to retrieve the GBFS feed
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGbfsForCity(city: string, observe?: 'body', reportProgress?: boolean): Observable<Gbfs>;
    public getGbfsForCity(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Gbfs>>;
    public getGbfsForCity(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Gbfs>>;
    public getGbfsForCity(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getGbfsForCity.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Gbfs>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/gbfs.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get geofencing zones
     * Retrieve the list of geofencing zones for a specific city.
     * @param city The name of the city for which geofencing zones are to be recovered
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGeofencingZonesForCity(city: string, observe?: 'body', reportProgress?: boolean): Observable<GeofencingZones>;
    public getGeofencingZonesForCity(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GeofencingZones>>;
    public getGeofencingZonesForCity(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GeofencingZones>>;
    public getGeofencingZonesForCity(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getGeofencingZonesForCity.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GeofencingZones>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/geofencing_zones.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get pricing plans
     * Retrieve the pricing plans available for the sharing service.
     * @param city The name of the city from which the pricing plans have to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPricingPlans(city: string, observe?: 'body', reportProgress?: boolean): Observable<SystemPricingPlans>;
    public getPricingPlans(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemPricingPlans>>;
    public getPricingPlans(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemPricingPlans>>;
    public getPricingPlans(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getPricingPlans.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SystemPricingPlans>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/system_pricing_plans.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get information about stations
     * Retrieve the list of vehicle stations for the specific city
     * @param city The name of the city from which the station information has to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStationInformation(city: string, observe?: 'body', reportProgress?: boolean): Observable<StationInformation>;
    public getStationInformation(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StationInformation>>;
    public getStationInformation(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StationInformation>>;
    public getStationInformation(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getStationInformation.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StationInformation>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/station_information.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the status of stations
     * Retrieves the current status of vehicle stations.
     * @param city The name of the city from which the station status has to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStationStatus(city: string, observe?: 'body', reportProgress?: boolean): Observable<StationStatus>;
    public getStationStatus(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StationStatus>>;
    public getStationStatus(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StationStatus>>;
    public getStationStatus(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getStationStatus.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StationStatus>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/station_status.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get system information
     * Retrieves general information about the sharing system.
     * @param city The name of the city from which the station status has to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSystemInformation(city: string, observe?: 'body', reportProgress?: boolean): Observable<SystemInformation>;
    public getSystemInformation(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemInformation>>;
    public getSystemInformation(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemInformation>>;
    public getSystemInformation(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getSystemInformation.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SystemInformation>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/system_information.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get system regions
     * Retrieve the list of the supported regions.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSystemRegions(observe?: 'body', reportProgress?: boolean): Observable<SystemRegions>;
    public getSystemRegions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemRegions>>;
    public getSystemRegions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemRegions>>;
    public getSystemRegions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SystemRegions>('get',`${this.basePath}/gbfs/system_regions.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the list of the vehicle types managed
     * Get vehicle types for a specific city
     * @param city The name of the city for which to retrieve vehicle types
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVehicleTypesForCity(city: string, observe?: 'body', reportProgress?: boolean): Observable<VehicleTypes>;
    public getVehicleTypesForCity(city: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VehicleTypes>>;
    public getVehicleTypesForCity(city: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VehicleTypes>>;
    public getVehicleTypesForCity(city: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (city === null || city === undefined) {
            throw new Error('Required parameter city was null or undefined when calling getVehicleTypesForCity.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VehicleTypes>('get',`${this.basePath}/gbfs/${encodeURIComponent(String(city))}/vehicle_types.json`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
